import { SEARCH_NAMES } from "constant/search/search";

export const DL_UNIT_PER_PAGE_MAX = 50;

export const UNIT_SEARCH_OPTIONS = [
  SEARCH_NAMES.SEARCH_TEXT,
  SEARCH_NAMES.LIMIT,
  SEARCH_NAMES.SKIP,
  SEARCH_NAMES.GROUP_SLUG,
  SEARCH_NAMES.INCLUDE_HM2,
  SEARCH_NAMES.U_TYPE,
  SEARCH_NAMES.DATUM,
  SEARCH_NAMES.DATUM_SECOND_RANGE,
  SEARCH_NAMES.DATUM_RANGE_TYPE,
  SEARCH_NAMES.AI_SEARCH,
] as const;

export type UnitSearchOptions = (typeof UNIT_SEARCH_OPTIONS)[number];

export const MAX_NUM_NAV = 30;

export const MAX_UNITS_EXCEL_EXPORT = 500;
